import {
    Box, Card, CardContent, Grid, Alert,
    IconButton, Menu, MenuItem, Typography,
    Stack, ListItemIcon, ListItemText, Link,
    FormControl, Input, InputLabel, InputAdornment
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';

import { GOOGLE_DRIVE_CDN } from '../../../constants/constants';
import { normalizeUrl } from '../../../helpers/admin/adminHelper';

const BannerCard = ({
    type, images, setBanner, open, typeTxt, anchorEl, anchorTxt,
    handleClick, handleClose, handleInputChange, handleClickOpenDialog
}) => {

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    // cambiar tipo de enlace
    const handleExternalClick = imgId => () => {
        setBanner(e => ({
            ...e,
            [type]: {
                ...e[type],
                images: e[type].images.map(i => (i.imgId === imgId) ? { ...i, external: !i.external } : i)
            }
        }));
    };

    return (
        <Grid item xl={4} lg={6}>
            <Card
                sx={{
                    borderRadius: '8px',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'
                }}
            >
                <Menu
                    anchorEl={ anchorEl }
                    open={ open }
                    onClose={ handleClose(anchorTxt) }
                >
                    <MenuItem onClick={ handleClickOpenDialog(anchorTxt) }>
                        <ListItemIcon>
                            <EditIcon />
                        </ListItemIcon>
                        <ListItemText>Editar</ListItemText>
                    </MenuItem>
                    <MenuItem>
                        <ListItemIcon>
                            <SaveIcon color='primary' />
                        </ListItemIcon>
                        <ListItemText>Guardar</ListItemText>
                    </MenuItem>
                </Menu>

                <CardContent>
                    <Box display='flex' justifyContent='space-between' flexWrap='wrap' gap='15px'>
                        <Typography variant='body1' sx={{ my: 'auto' }}>
                            { `Banners para ${typeTxt}` }
                        </Typography>
                        
                        <IconButton sx={{ my: 'auto' }}
                            onClick={ handleClick(type, anchorTxt) } >
                            <MoreVertIcon />
                        </IconButton>
                    </Box>

                    {
                        images.length > 0 ?
                            <div className='impulse_grid_container'>
                                {
                                    images.map(({ imgId, url, external }, i) => (
                                        <Stack key={i}>
                                            <div className='impulse_grid_item impulse_image'>
                                                <div className="impulse_img">
                                                    <img src={`${GOOGLE_DRIVE_CDN}${imgId}`}
                                                        alt="banner-nefropolis" />
                                                </div>
                                            </div>
                                            <FormControl fullWidth variant="standard">
                                                <InputLabel htmlFor="new-adornment-banner">
                                                    { `URL (${external ? 'externo' : 'local'})` }
                                                </InputLabel>
                                                <Input
                                                    id="new-adornment-banner"
                                                    value={url}
                                                    startAdornment={
                                                        !external &&
                                                            <InputAdornment position="start">
                                                                nefropolis.com
                                                            </InputAdornment>
                                                    }
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label={
                                                                    external ? 'external url' : 'local url'
                                                                }
                                                                onClick={handleExternalClick(imgId)}
                                                                onMouseDown={handleMouseDownPassword}
                                                                onMouseUp={handleMouseUpPassword}
                                                            >
                                                                {external ? <LinkOffIcon /> : <LinkIcon />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                    onChange={ handleInputChange(type, imgId) }
                                                />
                                            </FormControl>
                                            <Link href={
                                                normalizeUrl(`${!external ? `nefropolis.com${url}` : url}`)
                                            }
                                                target="_blank" rel="noopener noreferrer">
                                                Visitar enlace
                                            </Link>
                                        </Stack>
                                    ))
                                }
                            </div>
                        :
                            <Alert variant="outlined" severity="info">
                                Sin banners disponibles
                            </Alert>
                    }
                </CardContent>
            </Card>
        </Grid>
    );
};

export default BannerCard;